import { render, staticRenderFns } from "./ActivateAssetType.vue?vue&type=template&id=36d513be"
import script from "./ActivateAssetType.vue?vue&type=script&lang=js"
export * from "./ActivateAssetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports